<div class="account-setup">
  <div>
    <div class="col-12 mb-40">
      <mat-icon class="success-icon" svgIcon="checkmark-circle"></mat-icon>
    </div>
    <div class="col-12 mb-20">
      <div class="heading">
        <adp-label labelKey="Signup_Success_Heading_Text"></adp-label>
      </div>
    </div>
  </div>
  <div class="success-container container">
    <div class="row">
      <div class="col-12">
        <p class="text-center success-label">
          <adp-label labelKey="Signup_Create_Account_Success_Text"></adp-label>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-10">
        <button mat-flat-button color="accent" (click)="navigateToLogin()" [gtmClick]="getViewLabel('Signup_Create_Account_Success_Button')">
          <adp-label labelKey="Signup_Create_Account_Success_Button"></adp-label>
        </button>
      </div>
    </div>
  </div>
</div>
